import {checkPhone, email, password} from "./form";
import classNames from "classnames";
import buttonsStyles from "../components/baseComponents/gui/button/Button.module.scss";

export const NEXT_PUBLIC_BASE_URL = 'https://media.stoloto.ru'

export const header = {
  logoMain: {
    href: "https://www.stoloto.ru/?from=mediaStlt-button-main-stoloto",
    target: "_blank",
    className: "custom-header__logo_main",
    icon: "stoloto-logo",
    [`area-label`]: "перейти на stoloto.ru",
    title: "перейти на stoloto.ru",
  },
  logoMedia: {
    href: "/",
    className: "custom-header__logo_media",
    icon: "media-logo",
    [`area-label`]: "перейти на главную",
    title: "перейти на главную",
  },
  menuList: {
    customMenuItems: [
      {
        index: "1",
        itemsHref: "main",
        itemsText: "Главная"
      },
      {
        index: "2",
        itemsHref: "podcasts",
        itemsText: "Победители"
      },
      {
        index: "3",
        itemsHref: "prizes",
        itemsText: "Выигрыши"
      },
      {
        index: "4",
        itemsHref: "stores",
        itemsText: "Истории"
      },
      {
        index: "5",
        itemsHref: "news",
        itemsText: "Новости"
      },
      {
        index: "6",
        itemsHref: "about",
        itemsText: "Лотереи"
      },
      {
        index: "7",
        itemsHref: "fan",
        itemsText: "Развлечения"
      }
    ]
  },
  search: {
    icon: "search",
    input: {
      label: '',
      type: 'text',
      name: 'query',
      rules: {}
    }
  }
};


export const authorizationForm = {
  header: {
    base: {
      image: "/images/form/header/0.png",
      title: "заголовок заглушка",
      description: "описание заглушка"
    },
    image: [
      {
        states: ['start'],
        image: '/images/form/header/0.png'
      }
    ],
    title: [
      {
        states: ['start'],
        text: 'Войти или зарегистрироваться'
      }
    ],
    description: [
      {
        states: ['start'],
        text: 'чтобы получить доступ к&nbsp;лотереям и&nbsp;многомиллионным призам'
      }
    ]
  },
  content: {
    inputNumber: {
      condition: ['start'],
      select: [
        {
          icon: "",
          name: "Российская Федерация",
          code: ""
        },
        {
          icon: "",
          name: "Украина",
          code: ""
        },
        {
          icon: "",
          name: "Казахстан",
          code: ""
        },
        {
          icon: "",
          name: "Беларусь",
          code: ""
        },
        {
          icon: "",
          name: "Таджикистан",
          code: ""
        },
        {
          icon: "",
          name: "Молдавия",
          code: ""
        },
        {
          icon: "",
          name: "Узбекистан",
          code: ""
        },
        {
          icon: "",
          name: "Армения",
          code: ""
        },
        {
          icon: "",
          name: "Грузия",
          code: ""
        },
        {
          icon: "",
          name: "Азербайджан",
          code: ""
        },
      ],
      input: {
        label: 'Телефон',
        type: 'tel',
        name: 'tel',
        rules: checkPhone()
      }
    },
    enterEmailLink: {
      condition: ['start'],
      link: {}
    },
    button: {
      condition: ['enter-phone'],
      button: {}
    }
  },
  inputs: [
    {
      labelProps: {
        className: 'authorization-modal__label'
      },
      className: 'authorization-modal_input authorization-modal_input_name',
      label: 'Почта',
      type: 'email',
      name: 'login',
      rules: email()
    },
    {
      labelProps: {
        className: 'authorization-modal__label'
      },
      className: 'authorization-modal__input authorization-modal__input_name',
      label: 'Пароль',
      type: 'password',
      name: 'password',
      rules: password()
    }
  ],
  button: {
    attr: {
      className: "authorization-modal__button"
    },
    text: 'Отправить'
  }
};

export const codeButton = {
  text: "Отправить код повторно",
  tag: "button",
};
export const defaultTime = "4 мин";
export const defaultAuthor = {
  avatar: "/images/avatar.png",
  name: "Сафронова Анна"
};

export const defaultColor = 'white';
export const defaultNarrativeColor = '#212121';

export const defaultPrize = {
  title: "Джекпот 900 000 000₽",
  time: "2024, 3, 15, 8, 20",
  button: {
    tag: "button",
    href: "https://www.stoloto.ru/ruslotto/game?lastdraw=",
    target: "_blank",
    text: "Испытать удачу"
  },
};

export const footer = {
  logo: {
    attr: {
      href: "https://www.stoloto.ru",
      target: "_blank",
      [`area-label`]: "перейти на stoloto.ru",
      title: "перейти на stoloto.ru",
    },
    icon: "footer-logo",

  },
  text: "Информация об&nbsp;организаторах лотерей, о&nbsp;правилах их&nbsp;проведения, призовом фонде, количестве призов или выигрышей, сроках, месте и&nbsp;порядке их&nbsp;получения ― \nна&nbsp;<a href='https://www.stoloto.ru' target='_blank'>stoloto.ru</a>. Выигрыши носят вероятностный характер. Лотерея не&nbsp;является способом заработка и&nbsp;источником дохода. \n\nАО&nbsp;&laquo;ТК&nbsp;&laquo;Центр&raquo;, ОГРН 1127746385095, адрес: 109316, Москва, Волгоградский пр-т, д.&nbsp;43, корп.&nbsp;3, этаж&nbsp;10, пом. XXV, ком. 13Б. Реклама.&nbsp;18+",
  partner: {
    image: {
      imgAttr: {
        src: "/images/footer/part-logo.png",
        width: 80,
        height: 32
      }
    },
    text: "Организаторами лотерей являются Министерство спорта РФ  \nи Министерство финансов РФ."
  },
  app: {
    title: "Скачайте приложение «Столото»",
    text: "Наведите камеру на QR-код или нажмите  \nна кнопку, чтобы скачать мобильное приложение \n«Столото»",
    image: {
      sourceData: {
        sources: [
          {
            srcSet: "/images/footer/phone-m.svg",
            media: "(max-width:599px)"
          }
        ],
      },

      imgAttr: {
        src: "/images/footer/phone.png",
        width: 200,
        height: 206
      }
    },
    button: {
      attr: {
        tag: "a",
        href: "https://stolot.onelink.me/kuiR",
        "data-href": "https://stolot.onelink.me/kuiR",
        target: "_blank"
      },
      text: "Скачать",
      icon: "footer-btn-icon"
    }
  },
  socialBlock: {
    title: "Будьте в курсе всех новостей",
    list: [
      {
        href: "https://vk.com/stoloto",
        icon: "social/vk",
      },
      {
        href: "https://ok.ru/stoloto",
        icon: "social/ok",
      },
      {
        href: "https://t.me/aboutstoloto",
        icon: "social/tg",
      },
      {
        href: "https://rutube.ru/channel/23877067/",
        icon: "social/rt",
      }
    ]
  }
};


export const newsList = [
  {
    tags: [{text: "Новости"}],
    title: "Крупный выигрыш в лотерею: житель Москвы празднует победу с главным призом",
    date: "20 янв 2024",
    color: "#B58F25",
    time: "4 мин",
    author: {
      avatar: "/images/avatar.png",
      name: "Сафронова Анна"
    },
    image: "/images/news-test.png"
  },
  {
    tags: [{text: "Новости"}],
    title: "Крупный выигрыш в лотерею: житель Москвы празднует победу с главным призом",
    date: "20 янв 2024",
    time: "4 мин",
    color: "#3089D4",
    author: {
      avatar: "/images/avatar.png",
      name: "Сафронова Анна"
    },
    image: "/images/news-test.png"
  },
  {
    tags: [{text: "Новости"}],
    title: "Крупный выигрыш в лотерею: житель Москвы празднует победу с главным призом",
    date: "20 янв 2024",
    time: "4 мин",
    color: "#BD238C",
    author: {
      avatar: "/images/avatar.png",
      name: "Сафронова Анна"
    },
    image: "/images/news-test.png"
  },
  {
    tags: [{text: "Новости"}, {text: "Развлечение"}],
    title: "Крупный выигрыш в лотерею: житель Москвы празднует победу с главным призом",
    date: "20 янв 2024",
    time: "4 мин",
    color: "#CF2D2D",
    image: "/images/news-test.png"
  },
  {
    tags: [{text: "Новости"}],
    title: "Крупный выигрыш в лотерею: житель Москвы празднует победу с главным призом",
    date: "20 янв 2024",
    time: "4 мин",
    color: "#3089D4",
    image: "/images/news-test.png"
  },
  {
    tags: [{text: "Новости"}],
    title: "Крупный выигрыш в лотерею: житель Москвы празднует победу с главным призом",
    date: "20 янв 2024",
    time: "4 мин",
    image: "/images/news-test.png"
  },

];

export const navButtons = {
  buttonBack: {
    tag: "button",
    text: "Назад",
    icon: "news/back",
    className: classNames(buttonsStyles.button_back),
    href: "/",
  },
  buttonToTop: {
    [`area-label`]: "в начало",
    title: "в начало",
    icon: "news/up",
    className: classNames(
      buttonsStyles.button_white,
      buttonsStyles.button_icon,
      buttonsStyles.button_border,
      buttonsStyles.button_toTop,
    )
  }
};

export const commentsData = {
  currentUser: '125',
  totalPagesSection: 10,
  maxSizeComment: 1000,
  stub: {
    title: "Комментариев пока нет",
    text: "Напишите, что думаете по поводу этой статьи"
  },
  stubLogin: {
    text: "Войдите, чтобы оставлять комментарии",
    button: {
      text: "Войти"
    }
  }
};

export const moreCardsText = "Загрузить ещё";

export const projectTexts = {
  stub: "Скоро здесь появятся новые истории",
  toggle: {
    button: {
      text: 'сезон'
    }
  }
}

export const logoutModalContent = {
  title: "Вы уверены, что хотите выйти?",
  buttons: [
    {
      text: "Остаться"
    },
    {
      text: "Выйти"
    }
  ]
};

export const quizSubtitle = "Тест";

export const horoscopeTab = [
  {
    text: "вчера",
    id: "yesterday",
    period: "Day"
  },
  {
    text: "сегодня",
    id: "today",
    period: "Day"
  },
  {
    text: "завтра",
    id: "tomorrow",
    period: "Day"
  },
  {
    text: "неделя",
    id: "week",
    period: "Week"
  },
  {
    text: "месяц",
    id: "month",
    period: "Month"
  },
  {
    text: "2025",
    id: "year",
    period: "Year"
  }
];

export const prediction = {
  title: "Предсказания онлайн",
  text: "Что, если бы мы могли заглянуть в будущее и раскрыть секреты судьбы? Узнайте, что вас ждёт в скором времени, какие важные события могут произойти в жизни, а также, в какой момент улыбнётся удача.",
  rules: {
    title: "Как пользоваться предсказаниями?",
    text: "Определите, что бы вы хотели узнать. Попробуйте задать интересующий вопрос про себя — так, вы сможете сконцентрироваться на том, что действительно важно. А потом просто нажмите на кнопку «узнать», и звёзды непременно подскажут вам верный маршрут!"
  }
}

export const sharingList = [
  {
    link: "/tg",
    type: "tg",
    text: "text_tg"
  },
  {
    link: "/vk",
    type: "vk",
    text: "text_vk"
  },
  {
    link: "/ok",
    type: "ok",
    text: "text_ok"
  },
];
